var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUpvoteOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 28,
  viewBox: "0 0 27 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.8842 26.1951L19.0561 16.2845H25.3063C25.5715 16.2845 25.8129 16.1284 25.9296 15.8824C26.0442 15.6363 26.0184 15.341 25.8557 15.1245L14.0497 1.27983C13.9182 1.10266 13.7154 1 13.5004 1C13.2854 1 13.0826 1.10266 12.951 1.27983L1.14512 15.1245C1.04883 15.2525 1 15.4085 1 15.5646C1 15.6729 1.02376 15.7812 1.07122 15.8824C1.18789 16.1285 1.4293 16.2845 1.69447 16.2845H7.94466L7.77279 26.1951C7.77279 26.593 8.0834 26.915 8.46725 26.915H18.1898C18.5736 26.915 18.8842 26.593 18.8842 26.1951Z",
  stroke: "#001246",
  strokeWidth: 1.8
})));
export default SvgIconUpvoteOff;